import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const ConversationWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
  max-width: 1000px;
  min-height: 0;

  box-sizing: border-box;
`;
// padding-right: min(450px, 30vw);
// @media (max-width: 1200px) {
//   padding-right: min(300px, 25vw);
// }

// @media (max-width: 900px) {
//   padding-right: ${({ theme: { token } }) => token.paddingLG}px;
// }
